// @writing-suite/compile/typst (W5b): PDF through Typst. The source writer (`typstDocument`: TypstWriter and its
// regions), the print layout and its checks (`PrintLayout`, `printPreflight`), copyfit notes, `renderPrint` (up to
// five passes: ornaments at page edges, short spreads tracked ≤ 0.03 em looser, `evict(0)` between passes), PDF/X-1a
// for IngramSpark (`convertToPDFX`, `checkPDFX`), and `compilePDF(manuscript, preset, typst)` over the engine in
// @writing-suite/typst.
export {
  BOOK_PAGE_KINDS, blockKey, bookSetup, content, escape, escapeString, inlines, listOpening, markup, matterPage, parseBlockKey, regionText,
  typstDocument, typstFontFamilies, typstSource, utf8Length,
  type BlockKey, type DocumentOptions, type Region, type RegionKind, type TypstDocument,
} from './writer.ts';
export {
  characterCount, endsWithHyphen, hyphenated, lineWords, PrintLayout, readable,
  type LayoutRun, type Metrics, type PrintLine, type Spread, type TypstLayout,
} from './layout.ts';
export { cleanFontName, gutterFor, inches, PRINT_PLATFORMS, printPlatform, printPreflight, readPDF, type PrintOutput, type PrintPlatform } from './preflight.ts';
export { COPYFIT_AUTHOR, copyfitRemarks, type CopyfitRemark } from './copyfit.ts';
export { checkPDFX, containsRGBOperator, convertToPDFX, pdfDate, PDFX_CONFORMANCE, PDFX_VERSION } from './pdfx.ts';
export { PDFDict, PDFFailure, PDFFile, PDFLexer, serialize as serializePDFValue, V as PDFValues, type PDFObject, type PDFValue } from './pdfFile.ts';
export {
  compilePDF, previewPDF, renderPrint, typstRenderers,
  type CompiledPDFResult, type CompilePDFOptions, type PrintPass, type RenderedPrint, type RenderPrintOptions, type TypstEngine,
} from './render.ts';
